/* eslint-disable @typescript-eslint/no-explicit-any */

import { clearDasherToken, clearTrelloToken } from '@shared/index'
import { type Trello } from '../types/trello'
import { PUP_ID } from '../config'

export function getRemoveData (
  t: Trello.PowerUp.IFrame,
): any {
  clearTrelloToken(t, PUP_ID)
  clearDasherToken(t)
}
